import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { GroupDeleteConfirmationComponent } from "@app/directives/_misc/delete-confirm/group-delete-confirm/group-delete-confirm.component";
import { BackgroundImageDirective } from "@directives/_misc/backgroundImage";
import { DepotNameComponent } from "@directives/_misc/depotName/depotName.component";
import { MultiStepIndicatorComponent } from "@directives/_misc/multiStepIndicator/multiStepIndicator.component";
import { TooltipDirectiveAJS } from "@directives/_misc/tooltip/tooltip.directive.ajs";
import { TooltipService } from "@directives/_misc/tooltip/tooltip.service";
import * as angular from "angular";
import { AccountSwitcherComponent } from "./accountSwitcher/accountSwitcher.component";
import { BatteryIndicatorComponent } from "./batteryIndicator/batteryIndicator.component";
import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";
import { ConvertToNumberDirective } from "./convertToNumber";
import { CountToDirective } from "./countTo.directive.ajs";
import { DayOfWeekPickerComponent } from "./day-of-week-picker/day-of-week-picker.component";
import { DelayCreationDirective } from "./delayCreation.directive";
import { DeleteConfirmationComponent } from "./delete-confirm/delete-confirm.component";
import { DeleteConfirmComponent } from "./deleteConfirm/deleteConfirm";
import { DriverImageComponent } from "./driverImage/driverImage.component";
import { DriverUsernameDirective } from "./driverUsername";
import { VFlvPlayer } from "./flvPlayer/flv-player.component";
import { FullScreenButtonComponent } from "./fullScreenButton/fullScreenButton.component";
import { HideInProduction } from "./hideInProduction/hideInProduction";
import { HideOnIe } from "./hideOnIE/hideOnIE";
import { IfEnabled } from "./ifEnabled.directive.ajs";
import { IfUserInternal } from "./ifUserInternal.directive";
import { IfUserInternalOrFoundation } from "./ifUserInternalOrFoundation.directive";
import { IfUserNotInternal } from "./ifUserNotInternal.directive";
import { KeyWordTriggerDirective } from "./keyWordTrigger.directive";
import { LoadingIndicatorComponent } from "./loadingIndicator/loadingIndicator.component";
import { LocationInformationComponent } from "./location-information/location-information.component";
//import { NavCountComponent } from "@connexas/common-ui/navigation/navCount/navCount.component";
import { NavCountComponent } from "./navCount/navCount.component";
import { PopupComponent } from "./popup/popup.directive";
import { PrintElementDirective } from "./printElement/printElement.directive";
import { SiteStatusIndicatorComponent } from "./site-status-indicator/site-status-indicator.component";
import { SiteUpdatedIndicator } from "./site-updated-indicator/site-updated-indicator.component";
import { SnowComponent } from "./snow/snow.component";
import { TachoModeComponent, TachoModeStatusComponent } from "./tachoMode/tachoMode.directive";
import { TemperatureReadingComponent } from "./temperatureReading/temperatureReading.component";
import { TimeAgoComponent } from "./timeAgo.component";
import { TrendArrowComponent } from "./trendArrow/trendArrow.component";
import { UnitConversionSuffixComponent } from "./unitConversionSuffix.component";
import { VectorDotsComponent } from "./vector-dots/vector-dots.component";
import { VehicleOnlineStatusComponent } from "./vehicle-online-status-indicator/vehicle-online-status.component";
import { VeriDialogController } from "./veriDialog.controller";
import { VeriMarkerComponent } from "./veriMarker/veriMarker.directive";
import { VerticalCollapsableDivider } from "./vertical-collapsable-divider/vertical-collapsable-divider.component";
import { VideoDownloadStatusComponent } from "./video-download-status/video-download-status.component";

angular
    .module("app.misc.directives", [])

    .component("deleteConfirm", new DeleteConfirmComponent())
    .directive("deleteConfirmation", downgradeComponent({ component: DeleteConfirmationComponent }))
    .directive("groupDeleteConfirmation", downgradeComponent({ component: GroupDeleteConfirmationComponent }))
    .directive("accountSwitcher", downgradeComponent({ component: AccountSwitcherComponent }))

    .directive("convertToNumber", ConvertToNumberDirective.factory())
    .directive("backgroundImage", BackgroundImageDirective.factory())

    .directive("countTo", CountToDirective.factory())
    //.directive("countTo", downgradeComponent({ component: countToDirective }))
    .directive("delayCreation", DelayCreationDirective.factory())
    .directive('driverUsername', DriverUsernameDirective.factory())
    .directive("vFlvPlayer", downgradeComponent({ component: VFlvPlayer }))
    .directive("hideInProduction", HideInProduction.factory())
    .directive("hideOnIe", HideOnIe.factory())

    .service("tooltipService", downgradeInjectable(TooltipService))
    .directive("tooltip", TooltipDirectiveAJS.factory())

    .directive("ifUserInternal", IfUserInternal.factory())
    .directive("ifUserNotInternal", IfUserNotInternal.factory())
    .directive("ifUserInternalOrFoundation", IfUserInternalOrFoundation.factory())
    .directive("ifEnabled", IfEnabled.factory())
    .directive("keyWordTrigger", KeyWordTriggerDirective.factory())
    .directive("locationInformation", downgradeComponent({ component: LocationInformationComponent }))
    .directive("temperatureReading", downgradeComponent({ component: TemperatureReadingComponent }))
    .directive("multiStepIndicator", downgradeComponent({ component: MultiStepIndicatorComponent }))
    .directive("breadcrumbs", downgradeComponent({ component: BreadcrumbsComponent }))
    .directive("vehicleOnlineStatus", downgradeComponent({ component: VehicleOnlineStatusComponent }))
    .directive("videoDownloadStatus", downgradeComponent({ component: VideoDownloadStatusComponent }))
    .directive("navCount", downgradeComponent({ component: NavCountComponent }))
    .directive('printElement', PrintElementDirective.factory())

    .component("snow", new SnowComponent())
    .directive("driverImage", downgradeComponent({ component: DriverImageComponent }))
    .directive("vectorDots", downgradeComponent({ component: VectorDotsComponent }))

    .directive("dayOfWeekPicker", downgradeComponent({ component: DayOfWeekPickerComponent }))
    .directive("fullScreenButton", downgradeComponent({ component: FullScreenButtonComponent }))
    .directive("verticalCollapsableDivider", downgradeComponent({ component: VerticalCollapsableDivider }))

    .component("popup", new PopupComponent())
    .directive("batteryIndicator", downgradeComponent({ component: BatteryIndicatorComponent }))
    .directive("tachoMode", downgradeComponent({ component: TachoModeComponent }))
    .directive("tachoModeStatus", downgradeComponent({ component: TachoModeStatusComponent }))
    .component("timeAgo", new TimeAgoComponent())
    .directive("veriMarker", downgradeComponent({ component: VeriMarkerComponent }))
    .directive("unitConversionSuffix", downgradeComponent({ component: UnitConversionSuffixComponent }))
    .directive("trendArrow", downgradeComponent({ component: TrendArrowComponent }))
    .directive("loadingIndicator", downgradeComponent({ component: LoadingIndicatorComponent }))
    .directive("depotName", downgradeComponent({ component: DepotNameComponent }))
    .directive("siteStatusIndicator", downgradeComponent({ component: SiteStatusIndicatorComponent }))
    .component("siteUpdatedIndicator", new SiteUpdatedIndicator())

    .controller("veriDialogController", VeriDialogController as any)
    ;
